import { colorsPalettes } from "@similarweb/styles";

import { DefaultFetchService } from "app/services/fetchService";

export const fetchService = DefaultFetchService.getInstance();
export const WIDGET_TITLE_KEY = "seo.rankTracker.serpFeature.presence.title";
export const LEGEND_SCROLL_HEIGHT = "200px";
export const LEGEND_MAX_SELECTION = 10;
export const DEFAULT_COLOR = colorsPalettes.carbon[200];
export const LEGEND_DEFAULT_SELECTION = 5;

export const ME_AGAINST_SERP_GRAPH_CONFIG = {
    grouping: false,
};
export const SERP_FEATURE_BREAKDOWN_GRAPH_CONFIG = {
    stacking: "normal",
};
